
<h2 mat-dialog-title>Gestion des agendas</h2>
<div class="flex-container" fxLayout="row" fxLayoutGap="5px">
    <div fxFlex="50%"><app-agenda-list (agenda)="selectAgenda($event)"></app-agenda-list></div>
    <div fxFlex="150px">
        <mat-form-field appearance="standard">
            <mat-label>Catégorie</mat-label>
            <mat-select [(value)]="category">
                <mat-option *ngFor="let category of agendaCategories" [value]="category.type">
                  {{category.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>        
    </div>
    <div *ngIf="userConfig.switchGroups" fxFlex="150px">
        <mat-form-field appearance="standard">
            <mat-label>Site</mat-label>
            <mat-select [(value)]="domain">
                <mat-option *ngFor="let domain of userConfig.switchGroups" [value]="domain.id">
                  {{domain.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<mat-dialog-content>
    <app-agenda [scrollToCurrentHour]="true" [type]="category"></app-agenda>
</mat-dialog-content>
